import { createContext } from "react"

export const AppData = createContext(null)
export const AppDispatch = createContext(null)

export function appReducer(state, action) {
	switch (action.type) {
		case 'picture': return { ...state, picture: action.value }
		case 'gallery': return { ...state, gallery: action.value }
		case 'popover': return { ...state, popover: action.value }
		case 'heading': return { ...state, heading: action.value }
		default: throw Error('Unexpected action', action)
	}
}

export const initialState = {
	picture: null,
	gallery: null,
	popover: 'location',
	heading: 'down',
	galleries: {
		drinks: {
			data: await fetch('./uploads/Drinks/data.json').then(response => response.json()),
			path: 'uploads/Drinks'
		},
		staff: {
			data: await fetch('./uploads/Staff/data.json').then(response => response.json()),
			path: 'uploads/Staff'
		},
		vehicles: {
			data: await fetch('./uploads/Vehicles/data.json').then(response => response.json()),
			path: 'uploads/Vehicles'
		}
	}
}
